
export default [
  {
    id: 'printerseries_m10',
    name: 'TM M10',
  },
  {
    id: 'printerseries_m30',
    name: 'TM M30',
  },
  {
    id: 'printerseries_p20',
    name: 'TM P20',
  },
  {
    id: 'printerseries_p60',
    name: 'TM P60',
  },
  {
    id: 'printerseries_p60ii',
    name: 'TM P60II',
  },
  {
    id: 'printerseries_p80',
    name: 'TM P80',
  },
  {
    id: 'printerseries_t20',
    name: 'TM T20',
  },
  {
    id: 'printerseries_t60',
    name: 'TM T60',
  },
  {
    id: 'printerseries_t70',
    name: 'TM T70',
  },
  {
    id: 'printerseries_t81',
    name: 'TM T81',
  },
  {
    id: 'printerseries_t82',
    name: 'TM T82',
  },
  {
    id: 'printerseries_t83',
    name: 'TM T83',
  },
  {
    id: 'printerseries_t83iii',
    name: 'TM T83III',
  },
  {
    id: 'printerseries_t88',
    name: 'TM T88',
  },
  {
    id: 'printerseries_t90',
    name: 'TM T90',
  },
  {
    id: 'printerseries_t90kp',
    name: 'TM T90KP',
  },
  {
    id: 'printerseries_t100',
    name: 'TM T100',
  },
  {
    id: 'printerseries_u220',
    name: 'TM U220',
  },
  {
    id: 'printerseries_u330',
    name: 'TM U330',
  },
  {
    id: 'printerseries_l90',
    name: 'TM L90',
  },
  {
    id: 'printerseries_h6000',
    name: 'TM H6000',
  },
  {
    id: 'printerseries_m30ii',
    name: 'TM M30II',
  },
  {
    id: 'printerseries_ts100',
    name: 'TS_100',
  },
  {
    id: 'printerseries_m50',
    name: 'TM M50',
  },
  {
    id: 'printerseries_t88vii',
    name: 'TM T88VII',
  },
  {
    id: 'printerseries_l90lfc',
    name: 'TM L90LFC',
  },
  {
    id: 'printerseries_l100',
    name: 'TM L100',
  },
  {
    id: 'printerseries_p20ii',
    name: 'TM P20II',
  },
  {
    id: 'printerseries_p80ii',
    name: 'TM P80II',
  },
  {
    id: 'printerseries_m30iii',
    name: 'TM M30III',
  },
  {
    id: 'printerseries_m50ii',
    name: 'TM M50II',
  },
  {
    id: 'printerseries_m55',
    name: 'TM M55',
  },
  {
    id: 'printerseries_u220ii',
    name: 'TM U220II',
  },
];
